export default () => ({
  visible: true,
  accept() {
    const tenYears = 10 * 365 * 24 * 60 * 60;
    document.cookie = `cookielaw_accepted=1; Path=/; Max-Age=${tenYears}; SameSite=Lax`;
    window.location.reload();
  },
});
